export const History = ({ jobs }) => {
  return <div>Coming soon!</div>;
};
